// Admin configuration
// Add admin emails here to bypass waitlist requirements

export const ADMIN_EMAILS = [
  'ashish@wealthmanager.online',
  // Add more admin emails here as needed
  // 'admin2@wealthmanager.online',
  // 'support@wealthmanager.online'
];

export const isAdminUser = (email: string): boolean => {
  return ADMIN_EMAILS.includes(email.toLowerCase());
};

export const getAdminRole = (email: string): string | null => {
  if (isAdminUser(email)) {
    // You can extend this to return different admin roles
    return 'super_admin';
  }
  return null;
};